import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useRef, useMemo } from 'react';
import { Box } from '@chakra-ui/react';
import { motion, useReducedMotion } from 'framer-motion';
import { ThemeColorVariable, ThemeShadowVariable, } from '@caspeco/casper-ui-library.base-ui.theme';
import { useInlineDrawerKeydown } from './useDrawerKeyDown';
const ANIMATION_DURATION = 0.3;
export function InlineDrawer({ children, isOpen, onClose, closeOnEsc = true, size = 'xs', zIndex = 1, ...props }) {
    const drawerRef = useRef(null);
    useInlineDrawerKeydown({ isOpen, onClose, closeOnEsc });
    // Use same widhts as defined in drawer-theme.ts
    const width = useMemo(() => {
        switch (size) {
            case 'xs':
                return 320;
            case 'sm':
                return 448;
            case 'md':
                return 560;
            case 'lg':
                return 672;
            case 'xl':
                return 896;
            default:
                return 320;
        }
    }, [size]);
    const [hidden, setHidden] = useState(!isOpen);
    const shouldReduceMotion = useReducedMotion();
    let animate;
    // If reduce motion is enabled, we don't animate the drawer width, instead we just change the opacity
    if (isOpen) {
        animate = shouldReduceMotion ? { opacity: 1 } : { width };
    }
    else {
        animate = shouldReduceMotion ? { opacity: 0 } : { width: 0 };
    }
    return (_jsx(motion.aside, { ref: drawerRef, hidden: hidden, initial: false, onAnimationStart: () => setHidden(false), onAnimationComplete: () => setHidden(!isOpen), animate: animate, transition: {
            duration: ANIMATION_DURATION,
            ease: 'easeInOut',
        }, style: {
            backgroundColor: ThemeColorVariable.Surface,
            color: ThemeColorVariable.OnSurface,
            overflow: 'hidden',
            boxShadow: ThemeShadowVariable.Medium,
            height: '100dvh',
            top: '0',
            zIndex,
        }, children: _jsx(motion.div, { initial: { opacity: 0 }, animate: { opacity: isOpen ? 1 : 0 }, exit: { opacity: 0 }, transition: { duration: ANIMATION_DURATION, ease: 'easeInOut' }, style: { height: '100%', width: '100%' }, children: _jsx(Box, { h: "100%", w: "100%", overflowY: "auto", ...props, children: children }) }) }));
}
//# sourceMappingURL=inlineDrawer.js.map